const Packing = () => {
    return (
        <>
            Packing
        </>
    )

};

export default Packing;